// Safari has buggy iterators w/o `next`
module.exports = 'keys' in [] && !('next' in [].keys());


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/~/core-js/modules/$.iter-buggy.js
 ** module id = 130
 ** module chunks = 0
 **/